(function () {
  'use strict';

  function wireSliderArrows(root) {
    root.querySelectorAll('[data-subcollections-track]').forEach(function (track) {
      var wrap = track.closest('.subcollections__track-wrap');
      if (!wrap) return;
      var tiles = Array.prototype.slice.call(track.children);
      var prevBtn = wrap.querySelector('[data-subcollections-arrow="prev"]');
      var nextBtn = wrap.querySelector('[data-subcollections-arrow="next"]');
      if (!tiles.length || (!prevBtn && !nextBtn)) return;

      function updateDisabled() {
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -(tiles[0].offsetWidth + 20), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: tiles[0].offsetWidth + 20, behavior: 'smooth' });
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateDisabled();
          ticking = false;
        });
      }, { passive: true });

      updateDisabled();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    wireSliderArrows(document);
  });
}());
